import type { Catalog } from "../../en";

/** Filipino: lead routing dialog (mirrors en/engage/routing.ts). */
export const routing: Catalog["engage"]["routing"] = {
  open: "Lead routing",
  title: "Lead routing",
  subtitle: "Kung kanino mapupunta ang mga bagong lead, at kung saan ipinapadala ang mga email tungkol sa lead.",
  loadError: "Hindi ma-load ang lead routing.",
  mode: {
    label: "Pag-assign ng mga bagong lead",
    round_robin: "Round-robin",
    round_robinHint: "Pantay na ipinapamahagi ang mga bagong lead sa mga aktibong teammate na puwedeng mag-edit ng lead.",
    default_owner: "Laging iisang tao",
    default_ownerHint: "Lahat ng bagong lead ay mapupunta sa isang teammate. Kung umalis siya o nawalan ng access, round-robin ang papalit.",
  },
  owner: {
    label: "Default na may-ari",
    placeholder: "Pumili ng teammate",
    required: "Piliin kung kanino mapupunta ang mga bagong lead.",
  },
  email: {
    label: "Shared na inbox ng mga lead",
    optional: "(opsyonal)",
    hint: "Natatanggap din ng address na ito ang email na “Bagong lead”, halimbawa leads@yourschool.ph.",
    placeholder: "leads@example.ph",
    invalid: "Maglagay ng wastong email address.",
  },
  readOnly: "Makikita mo kung paano nire-route ang mga lead. Kailangan ng pahintulot na mag-edit ng lead para baguhin ito.",
  save: "I-save ang routing",
  saved: "Na-save ang lead routing",
};
